import React, { useContext } from "react";
import { Tab } from "semantic-ui-react";
import TransmissionStore from "../../../app/stores/transmissionStore";
import BogTab from "./BogTab";
import DesignTab from "./DesignTab";
import HOPTab from "./HOPTab";
import LogTab from "./LogTab";
import MaterialTab from "./MaterialTab";
import ProjectScopeTab from "./ProjectScopeTab";
import SiteAccessTab from "./SiteAccessTab";
import TechnicianTab from "./TechnicianTab";

const TransmissionTab = () => {
  const transmissionStore = useContext(TransmissionStore);
  const {activeDetailTab, setActiveDetailTab} = transmissionStore;
  const panes = [
    { menuItem: "Project Scope", render: () => <ProjectScopeTab/> },
    { menuItem: "Design", render: () => <DesignTab/> },
    { menuItem: "Material", render: () => <MaterialTab/> },
    { menuItem: "HOP", render: () => <HOPTab/> },
    { menuItem: "Project Site Access", render: () => <SiteAccessTab/> },
    { menuItem: "Technician", render: () => <TechnicianTab/> },
    { menuItem: "BOG", render: () => <BogTab/> },
    { menuItem: "Log", render: () => <LogTab/> },
  ];
  return (
    <div>
      <Tab 
      panes={panes} 
      onTabChange={(e, data) => setActiveDetailTab(Number(data.activeIndex))}
      defaultActiveIndex={activeDetailTab}
      />
      
    </div>
  );
};
export default TransmissionTab;
